<template>
  <div class="body">
    <!-- Menubar -->
    <Menubar :model="items" class="z-menubar" v-if="this.ToastMenubarShow">
      <template #start>
        <img alt="logo" :src="require(`@/assets/logo/logo1.png`)" height="30" class="p-mr-2" />
      </template>

      <template #end>
        <div class="flex items-center gap-2">
          <Button :label="this.KullaniciBilgi.AdSoyad" severity="warn" text icon="pi pi-user"
            aria-controls="overlay_menu" @click="toggle" aria-haspopup="true">
          </Button>

          <Menu ref="menu" id="overlay_menu" :model="items_popup" :popup="true">
            <template #item="{ item, props }">
              <router-link v-if="item.route" v-slot="{ href, navigate }" :to="item.route" custom>
                <a :href="href" v-bind="props.action" @click="navigate">
                  <span :class="item.icon" />
                  <span class="ml-2">{{ item.label }}</span>
                </a>
              </router-link>
              <a v-else-if="item.url" :href="item.url" :target="item.target" v-bind="props.action">
                <span :class="item.icon" />
                <span class="ml-2">{{ item.label }}</span>
              </a>
              <a v-else :href="item.click" @click="item.click" v-bind="props.action">
                <span :class="item.icon" />
                <span class="ml-2">{{ item.label }}</span>
              </a>
            </template>
          </Menu>
        </div>
      </template>
    </Menubar>

    <!-- Toast Menubar -->
    <Menubar :model="items2" class="z-menubar" v-if="this.MenubarShow">
      <template #start>
        <img alt="logo" :src="require(`@/assets/logo/logo1.png`)" height="30" class="p-mr-2" />
      </template>

      <template #end>
        <div class="flex items-center gap-2">
          <Button :label="this.KullaniciBilgi.AdSoyad" severity="warn" text icon="pi pi-user"
            aria-controls="overlay_menu" @click="toggle" aria-haspopup="true" />
          <Menu ref="menu" id="overlay_menu" :model="items_popup" :popup="true">
            <template #item="{ item, props }">
              <router-link v-if="item.route" v-slot="{ href, navigate }" :to="item.route" custom>
                <a :href="href" v-bind="props.action" @click="navigate">
                  <span :class="item.icon" />
                  <span class="ml-2">{{ item.label }}</span>
                </a>
              </router-link>
              <a v-else-if="item.url" :href="item.url" :target="item.target" v-bind="props.action">
                <span :class="item.icon" />
                <span class="ml-2">{{ item.label }}</span>
              </a>
              <a v-else :href="item.click" @click="item.click" v-bind="props.action">
                <span :class="item.icon" />
                <span class="ml-2">{{ item.label }}</span>
              </a>
            </template>
          </Menu>
        </div>
      </template>
    </Menubar>

    <!-- TieredMenu -->
    <div class="grid  mr-1 mt-1">
      <div class="col-2" v-if="this.TieredMenuShow">
        <TieredMenu :model="items" class="z-menubar">
          <template #item="{ item, props, hasSubmenu }">
            <router-link v-if="item.route" v-slot="{ href, navigate }" :to="item.route" custom>
              <a :href="href" v-bind="props.action" @click="navigate">
                <span :class="item.icon" />
                <span class="ml-2">{{ item.label }}</span>
              </a>
            </router-link>
            <a v-else :href="item.url" :target="item.target" v-bind="props.action">
              <span :class="item.icon" />
              <span class="ml-2">{{ item.label }}</span>
              <span v-if="hasSubmenu" class="pi pi-angle-right ml-auto" />
            </a>
          </template>
        </TieredMenu>
      </div>

      <div :class="this.RouterView">
        <ScrollPanel style="width: 100%;" :style="{ 'height': (windowHeight - 67) + 'px' }">
          <router-view>
          </router-view>
        </ScrollPanel>
      </div>
    </div>
    <!-- <div class="footer">
      test
    </div> -->
  </div>
</template>

<script>
import GlobalServis from "../../services/GlobalServis";
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,

      TieredMenuShow: false,
      MenubarShow: false,
      ToastMenubarShow: false,
      RouterView: "col-10",

      KullaniciBilgi: [],
      tempitems: [],
      items: [],
      items2: [],
      loading: false,
      items_popup: [
        {
          label: 'Ayarlar',
          icon: 'pi pi-cog',
          command: () => {
            this.$router.push({ path: "/Kullanici/Ayarlar" })
          }
        },
        {
          label: 'Arkaplan İşleri',
          icon: 'pi pi-sync',
          command: () => {
            this.$toast.add({
              severity: "warn",
              summary: "Pek Yakında... ",
              // detail: this.message,
              life: 3000,
            });
          }
        },
        {
          separator: true
        },
        {
          label: 'Test Button',
          icon: 'pi pi-ellipsis-h',
          command: () => {
            GlobalServis.GlobalServis("GET", "GetTestButton", "").then(
              (res) => {
                if (res.status == 200) {
                  this._tempitems = res.data;
                } else if (res.status == 400) {
                  this.$toast.add({
                    severity: "error",
                    summary: "Hata",
                    detail: "Önemli bir hata meydana geldi",
                    life: 3000,
                  });
                } else {
                  this.$toast.add({
                    severity: "error",
                    summary: "Hata",
                    detail: "Bilinmeyen bir hata meydana geldi",
                    life: 3000,
                  });
                }
              })
          }
        },
        {
          separator: true
        },
        {
          label: 'Çıkış',
          icon: 'pi pi-sign-out',
          command: () => {  this.Logout() }
        },
      ],
    }
  },
  methods: {
    toggle(event) {
      this.$refs.menu.toggle(event);
    },

    // load() {
    //   this.loading = true;
    //   setTimeout(() => {
    //     this.loading = false;
    //   }, 2000);
    // },
    Logout() {
      this.$store.dispatch("auth/logout").then(() => {     
        this.$router.push({ path: "/Auth/Login" });
      },
        (error) => {
          this.loading = false;
          this.message =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.$toast.add({
            severity: "warn",
            summary: "Çıkış Hatası",
            detail: this.message,
            life: 3000,
          });
        }
      );
    },
    _GetNavbar() {
      GlobalServis.GlobalServis("GET", "GetNavbar", "").then(
        (res) => {
          if (res.status == 200) {
            this._tempitems = res.data;
          } else if (res.status == 400) {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Önemli bir hata meydana geldi",
              life: 3000,
            });
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Hata",
              detail: "Bilinmeyen bir hata meydana geldi",
              life: 3000,
            });
          }
        }
      ).then(() => {
        let temp_ = []
        let counter = 0
        this._tempitems.forEach((value) => {
          if (value.UstMenu == 0) {
            temp_.push({
              label: value.Tanim,
              url: value.Url,
              icon: "pi " + value.IconAd
            })
            // if (value.Seperator === true) {
            //   temp_.push({
            //     separator: true
            //   });
            // }
// eslint-disable-next-line
            let counter2 = 0;
            let _tempSubMenu = []
            this._tempitems.forEach(value2 => {
              if (value.YetkiYeri_rowid == value2.UstMenu) {

                _tempSubMenu.push({
                  label: value2.Tanim,
                  url: value2.Url,
                  icon: "pi " + value2.IconAd,
                })
                temp_[counter].items = _tempSubMenu;

                if (value2.Seperator === true) {
                  _tempSubMenu.push({
                    separator: true
                  })
                }
                // eslint-disable-next-line
                counter2++;
                temp_[counter].items = _tempSubMenu
              }
            })
            counter++;
          }
        })
        // temp_.push({
        //   label: "Quit",
        //   // url: "/Cikis",
        //   command: () => this.Logout(),
        //   icon: "pi  pi-power-off"
        // })
        this.items = temp_

      })
    },
    _KullaniciBilgisi() {
      GlobalServis.GlobalServis("GET", "GetKullaniciBilgi_AdRol", "").then((res) => {
        if (res.status == 200) {
          console.log(res.data[0]);
          
          this.KullaniciBilgi = res.data[0];
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
    onResize() {
      this.windowHeight = window.innerHeight
      this.windowWidth = window.innerWidth

      if (this.windowWidth < 960) {
        this.TieredMenuShow = false;
        this.ToastMenubarShow = true;
        this.MenubarShow = false;
        this.RouterView = "col-12";
      }
      else {
        this.TieredMenuShow = true;
        this.ToastMenubarShow = false;
        this.MenubarShow = true;
        this.RouterView = "col-10";
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
    this.onResize();
    this._GetNavbar();
    this._KullaniciBilgisi();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onResize);
  },
  created() {
  },
  comments: {
  }
};
</script>
<style scoped>
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #044389;
  color: white;
  text-align: center;
}
</style>